import React, { useState } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

/**
 * Metronic Demo1 Layout Wrapper
 * Professional CRM-style layout with sidebar and header
 *
 * @param {React.ReactNode} children - Page content
 */
export function MetronicLayout({ children }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {/* Desktop Sidebar - Fixed left */}
      <Sidebar isCollapsed={sidebarCollapsed} onToggle={setSidebarCollapsed} />

      {/* Main Content Area */}
      <div className={`flex flex-col flex-1 overflow-hidden transition-all duration-300 ${sidebarCollapsed ? 'lg:ml-0' : 'lg:ml-64'}`}>
        {/* Header - Sticky top */}
        <Header />

        {/* Page Content - Scrollable */}
        <main className="flex-1 overflow-y-auto">
          {children}
        </main>
      </div>
    </div>
  );
}

export default MetronicLayout;

